import { RestClient } from './../Client';
import { buildFileFormData, type FileUploadData } from '../utils';

type UploadResult = {
  [key: `${string}Path`]: string;
  [key: `${string}Encoding`]: string;
};

/** /file-storage/upload-agent-attachment のレスポンス。keyはserverが生成するS3 object key */
type AgentAttachmentUploadResult = {
  key: string;
  fileName: string;
  mimeType: string;
};

/** /file-storage/url のレスポンス。短期間だけ有効な presigned GET URL */
type FileUrlResult = {
  url: string;
};

/**
 * FormDataを生成し、ファイルストレージにアップロードする汎用関数
 * @param fileMap - フォームデータに含めるファイルのマップ（キーはフォームデータのフィールド名、値はImportFileField）
 * @returns UploadResult - アップロードされたファイルのパスとエンコーディング情報
 */
async function uploadFiles(fileMap: Map<string, FileUploadData>): Promise<UploadResult> {
  const formData = buildFileFormData(fileMap);
  return await RestClient.fa.formPost<UploadResult>('/file-storage/upload', formData, {
    largeBody: true,
  });
}

/**
 * Agent Chatの添付ファイル1件をファイルストレージにアップロードする
 * @param file - アップロードするファイル
 * @returns AgentAttachmentUploadResult - serverが生成したS3 keyと最小metadata
 */
async function uploadAgentAttachment(file: File): Promise<AgentAttachmentUploadResult> {
  const formData = new FormData();
  formData.append('file', file);
  return await RestClient.fa.formPost<AgentAttachmentUploadResult>(
    '/file-storage/upload-agent-attachment',
    formData,
    { largeBody: true },
  );
}

/**
 * S3 object key から表示用の短期 URL を取得する
 * @param storageName - server が生成した S3 object key
 * @returns FileUrlResult - presigned GET URL
 */
async function getFileUrl(storageName: string): Promise<FileUrlResult> {
  return await RestClient.fa.get<FileUrlResult>('/file-storage/url', { storageName });
}

export type { AgentAttachmentUploadResult, FileUrlResult, UploadResult };
export { getFileUrl, uploadAgentAttachment, uploadFiles };
